import { defineMessages } from 'react-intl'

export default defineMessages({
  mediaPlaceholder: {
    id: 'containers.EmbeddedDealPage.components.Drafts.TaskRow.mediaPlaceholder',
    defaultMessage: 'Media',
  },
  territoryMarketPlaceholder: {
    id: 'containers.EmbeddedDealPage.components.Drafts.TaskRow.territoryMarketPlaceholder',
    defaultMessage: 'Territory/Market',
  },
  usagePlaceholder: {
    id: 'containers.EmbeddedDealPage.components.Drafts.TaskRow.usagePlaceholder',
    defaultMessage: 'Airing time',
  },
  usageRights: {
    id: 'containers.EmbeddedDealPage.components.Drafts.TaskRow.usageRights',
    defaultMessage: 'Usage Rights',
  },
  missingUsage: {
    id: 'containers.EmbeddedDealPage.components.Drafts.TaskRow.missingUsage',
    defaultMessage: 'Missing Usage',
  },
})
